import { takeLatest, put, call } from "redux-saga/effects";
import {
  fetchPersonalRatesWithCreditCards,
  fetchPersonalRatesWithoutCreditCards,
} from "network/services/rates";
import type { ISaga } from "../types";
import {
  getAllPersonalLoanRatesError,
  getAllPersonalLoanRatesSuccess,
} from "../actionCreators";

function* processGetAllPersonalRates(): ISaga {
  try {
    const { data: withCC } = yield call(fetchPersonalRatesWithCreditCards);
    const { data: withoutCC } = yield call(
      fetchPersonalRatesWithoutCreditCards
    );

    const payload = {
      withCC,
      withoutCC,
    };

    yield put(getAllPersonalLoanRatesSuccess(payload));
  } catch (e) {
    console.error("GETTING LIST OF PERSONAL LOAN RATES FAILED", e);
    put(getAllPersonalLoanRatesError());
  }
}

export default function* watcher() {
  yield takeLatest(
    "REQUEST_PERSONAL_LOAN_RATES_DATA",
    processGetAllPersonalRates
  );
}
